export type SummaryEventTone = 'info' | 'warning' | 'critical'

export const EVENT_DOT_CLASS: Record<SummaryEventTone, string> = {
  info: 'bg-st-info',
  warning: 'bg-st-warn',
  critical: 'bg-st-down'
}

export const EVENT_ACCENT_BORDER_CLASS: Record<SummaryEventTone, string> = {
  info: 'border-l-st-info',
  warning: 'border-l-st-warn',
  critical: 'border-l-st-down'
}

export const EVENT_PILL_CLASS: Record<SummaryEventTone, string> = {
  info: 'bg-st-info-bg text-st-info',
  warning: 'bg-st-warn-bg text-st-warn',
  critical: 'bg-st-down-bg text-st-down'
}
